import { compose } from "redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { Field } from "redux-form/immutable";

import { BasePageTitle } from "altus-ui-components";

import TextField from "app/components/form/TextField";
import { SUB_CONTRACTOR_FORM } from "features/planner/planner.constants";

class SubContractorDetailsForm extends PureComponent {
  render() {
    return (
      <Grid
        container
        direction="column"
        item
        xs={12}
        lg={6}
        style={{
          display: "block",
        }}
      >
        <Grid item>
          <BasePageTitle title="Sub Contractor" />
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={6}>
            <Field
              label="First Name"
              defaultValue="-"
              component={TextField}
              name={SUB_CONTRACTOR_FORM.FIRST_NAME}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              label="Last Name"
              defaultValue="-"
              component={TextField}
              name={SUB_CONTRACTOR_FORM.LAST_NAME}
            />
          </Grid>
        </Grid>

        <Grid item xs>
          <Field
            defaultValue="-"
            label="E-mail"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.EMAIL_WORK}
          />
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: 16 }}>
            <Field
              label="Phone"
              defaultValue="-"
              component={TextField}
              name={SUB_CONTRACTOR_FORM.PHONE}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              defaultValue="-"
              label="Cell phone"
              component={TextField}
              name={SUB_CONTRACTOR_FORM.CELL_PHONE}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Field
            rows={5}
            multiline
            label="Notes"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.NOTES}
          ></Field>
        </Grid>
      </Grid>
    );
  }
}

export default compose()(SubContractorDetailsForm);
